export const styles = {
  Form: {
    width: '100%'
  },
  FormField: {
    width: '100%',
    border: 'none',
    padding: 0,
    marginX: 0
  },
  FormLabel: {
    display: 'block',
    lineHeight: 'default'
  },
  FormHeader: {
    margin: 0
  }
};
